<div class="row justify-content-center">
  <div class="col-md-10 table-responsive">
    <table class="table table-borderless text-start mt-4 table-hover">
      <thead>
            <tr>
              <th>Institution</th>
              <th>Process Cycle</th>
              <th>Exclusion Reason</th>
              <th>Disbursement Run Date</th>
            </tr>
      </thead>
          <tbody>             
            <tr *ngFor="let disbursementExclusion of disbursementExclusions">
              <td>{{disbursementExclusion?.institutionName}}</td>
              <td>{{disbursementExclusion?.processCycleName}}</td>
              <td>{{disbursementExclusion?.exclusionReason}}</td>
              <td>{{disbursementExclusion?.disbursementRunDate}}</td>
            </tr>
          </tbody>
          </table>
  </div>
  <mat-dialog-actions align="end">
    <!-- <button btn-primary mat-dialog-close>Close</button> -->
    <button type="button" mat-dialog-close class="btn btn-primary">Close</button>
  </mat-dialog-actions>
</div>

